export default function formatSeconds(seconds) {
  const hours   = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs    = seconds % 60;

  return [hours, minutes, secs].map((n) => String(n).padStart(2, '0')).join(':');
}
